import React from 'react';
import { Globe, Shield, Clock } from 'lucide-react';
interface ScreenProps {
  onNavigate: (screenId: number) => void;
}
export function Screen7({
  onNavigate
}: ScreenProps) {
  return <div className="min-h-full bg-datmont-900 flex flex-col relative overflow-hidden" data-id="element-283">
      {/* Header */}
      <div className="px-6 pt-6 pb-4 relative z-10" data-id="element-284">
        <h1 className="text-lg font-bold text-white text-center" data-id="element-285">
          Datmont Active Network
        </h1>
      </div>

      {/* Network Map Visualization (CSS-based) */}
      <div className="relative h-64 w-full flex items-center justify-center my-4" data-id="element-286">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-datmont-blue/20 via-datmont-900 to-datmont-900" data-id="element-287"></div>

        {/* Abstract glowing nodes representing global connections */}
        <div className="relative w-full h-full max-w-sm mx-auto" data-id="element-288">
          {/* North America */}
          <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-blue-400 rounded-full shadow-[0_0_10px_rgba(96,165,250,0.8)] animate-pulse" data-id="element-289"></div>
          <div className="absolute top-1/3 left-1/5 w-1.5 h-1.5 bg-blue-300 rounded-full shadow-[0_0_8px_rgba(147,197,253,0.8)]" data-id="element-290"></div>

          {/* Europe */}
          <div className="absolute top-1/4 right-1/3 w-2.5 h-2.5 bg-blue-400 rounded-full shadow-[0_0_12px_rgba(96,165,250,0.9)] animate-pulse" style={{
          animationDelay: '0.5s'
        }} data-id="element-291"></div>
          <div className="absolute top-1/3 right-1/4 w-1.5 h-1.5 bg-blue-300 rounded-full shadow-[0_0_8px_rgba(147,197,253,0.8)]" data-id="element-292"></div>

          {/* Middle East / Asia */}
          <div className="absolute top-1/2 right-1/4 w-2 h-2 bg-blue-400 rounded-full shadow-[0_0_10px_rgba(96,165,250,0.8)] animate-pulse" style={{
          animationDelay: '1s'
        }} data-id="element-293"></div>
          <div className="absolute top-2/3 right-1/5 w-1.5 h-1.5 bg-blue-300 rounded-full shadow-[0_0_8px_rgba(147,197,253,0.8)]" data-id="element-294"></div>

          {/* Connecting Lines (SVG) */}
          <svg className="absolute inset-0 w-full h-full opacity-30" style={{
          filter: 'drop-shadow(0 0 4px rgba(96,165,250,0.5))'
        }} data-id="element-295">
            <path d="M 90 60 Q 150 40 220 60" fill="none" stroke="#60A5FA" strokeWidth="1" strokeDasharray="4 4" data-id="element-296" />
            <path d="M 220 60 Q 250 90 260 120" fill="none" stroke="#60A5FA" strokeWidth="1" strokeDasharray="4 4" data-id="element-297" />
            <path d="M 90 60 Q 150 100 260 120" fill="none" stroke="#60A5FA" strokeWidth="0.5" data-id="element-298" />
          </svg>

          <Globe className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 text-datmont-blue/10" strokeWidth={0.5} data-id="element-299" />
        </div>
      </div>

      {/* Stats */}
      <div className="px-6 flex gap-4 mb-8 relative z-10" data-id="element-300">
        <div className="flex-1 bg-white/5 border border-white/10 rounded-2xl p-4 text-center backdrop-blur-sm" data-id="element-301">
          <div className="text-2xl font-bold text-white mb-1" data-id="element-302">2.4M</div>
          <div className="text-[10px] text-slate-400 uppercase tracking-wider" data-id="element-303">
            Verifications Today
          </div>
        </div>
        <div className="flex-1 bg-white/5 border border-white/10 rounded-2xl p-4 text-center backdrop-blur-sm" data-id="element-304">
          <div className="text-2xl font-bold text-white mb-1" data-id="element-305">120</div>
          <div className="text-[10px] text-slate-400 uppercase tracking-wider" data-id="element-306">
            Issuers Connected
          </div>
        </div>
      </div>

      {/* Recent Activity */}
      <div className="flex-1 bg-datmont-800/50 rounded-t-3xl border-t border-white/10 p-6 relative z-10" data-id="element-307">
        <h2 className="text-sm font-bold text-white mb-4" data-id="element-308">
          Recent Network Activity
        </h2>

        <div className="space-y-4" data-id="element-309">
          <div className="flex items-center justify-between" data-id="element-310">
            <div className="flex items-center gap-3" data-id="element-311">
              <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-white font-serif font-bold text-[10px] border border-yellow-500/50" data-id="element-312">
                FBI
              </div>
              <div data-id="element-313">
                <p className="text-sm font-bold text-white" data-id="element-314">FBI – USA</p>
                <p className="text-[10px] text-slate-400" data-id="element-315">Document Verified</p>
              </div>
            </div>
            <span className="text-[10px] text-slate-500" data-id="element-316">2 sec ago</span>
          </div>

          <div className="flex items-center justify-between" data-id="element-317">
            <div className="flex items-center gap-3" data-id="element-318">
              <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-white border border-white/20" data-id="element-319">
                <Shield className="w-5 h-5 text-slate-300" data-id="element-320" />
              </div>
              <div data-id="element-321">
                <p className="text-sm font-bold text-white" data-id="element-322">Home Office – UK</p>
                <p className="text-[10px] text-slate-400" data-id="element-323">Document Verified</p>
              </div>
            </div>
            <span className="text-[10px] text-slate-500" data-id="element-324">5 sec ago</span>
          </div>

          <div className="flex items-center justify-between" data-id="element-325">
            <div className="flex items-center gap-3" data-id="element-326">
              <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-white border border-yellow-500/50" data-id="element-327">
                <Globe className="w-5 h-5 text-yellow-500/80" data-id="element-328" />
              </div>
              <div data-id="element-329">
                <p className="text-sm font-bold text-white" data-id="element-330">
                  Ministry of Interior – UAE
                </p>
                <p className="text-[10px] text-slate-400" data-id="element-331">Document Verified</p>
              </div>
            </div>
            <span className="text-[10px] text-slate-500" data-id="element-332">8 sec ago</span>
          </div>
        </div>
      </div>
    </div>;
}